import React from 'react';
import toast, { Toaster } from 'react-hot-toast';

import {confirmAlert} from "react-confirm-alert";
import Role from "../../../inc/Role";
import {NavLink, useNavigate} from "react-router-dom";
import * as Icon from "react-bootstrap-icons";
import {Config} from '../../../Config'
import moment from "moment-timezone";
import * as Utils from "../../../inc/Utils";
import Select from 'react-select'
import DatePicker from "react-datepicker";

export default function CampaignTemplateCreateMasterURL(props) {
    const roles = new Role();
    let userId = roles.loginUserId;

    let btnTextDefault = 'บันทึกข้อมูล';
    let btnTextLoading = 'กำลังบันทึก..';
    let [isLoading, setLoading] = React.useState(false); 
    const navigate = useNavigate();

    let [lang, setLanguage] = React.useState(null);
    let [langId, setLanguageId] = React.useState(null);
    let [projectType, setProjectType] = React.useState(null);
    let [projectTypeId, setProjectTypeId] = React.useState(null);
    let [project, setProject] = React.useState(null);
    let [projectId, setProjectId] = React.useState(null);
    let [typeId, setTypeId] = React.useState(null);
    let [masterUrlPlaceholder, setMasterUrlPlaceholder] = React.useState('...');
    let [masterUrl, setMasterUrl] = React.useState(null);
    let [masterUrlId, setMasterUrlId] = React.useState(null);
    let [disableMasterUrl, setDisableMasterUrl] = React.useState(true);
    let [masterUrlText, setMasterUrlText] = React.useState(null);
    let [masterUrlFor, setMasterUrlFor] = React.useState(null);
    let [masterUrlForId, setMasterUrlForId] = React.useState(null);

    let [campaignDate, setCampaignDate] = React.useState(null);
    let [campaign, setCampaign] = React.useState(null);
    let [campaignId, setCampaignId] = React.useState(null);

    let [projectPlaceholder, setProjectPlaceholder] = React.useState('...');
    let [campaignPlaceholder, setCampaignPlaceholder] = React.useState('...');

    let [disableProject, setDisableProject] = React.useState(true);
    let [disableCampaign, setDisableCampaign] = React.useState(true);

    //Promotion
    let [campaignType, setCampaignType] = React.useState(null);
    let [campaignTypeId, setCampaignTypeId] = React.useState(null);
    let [buType, setBuType] = React.useState(null);
    let [buTypeId, setBuTypeId] = React.useState(null);
    let [agency, setAgency] = React.useState(null);

    React.useEffect(() => {
        setTypeId(props.typeId);

        (async function() {
            try {
                const resAgency = await Utils.getAgency();
                setAgency(resAgency);

                const resLanguage = await Utils.getLanguage();
                setLanguage(resLanguage);

                const resProjectType = await Utils.getProjectType();
                setProjectType(resProjectType);

                const resMasterUrlFor = await Utils.getMasterURLFor();
                setMasterUrlFor(resMasterUrlFor);

                setDisableMasterUrl(true);
                setMasterUrlPlaceholder('กำลังโหลด...');
                const resMasterURL = await Utils.getMasterUrl();
                setMasterUrl(resMasterURL);
                setMasterUrlPlaceholder('Select...');
                setDisableMasterUrl(false);

                setDisableProject(true);
                setDisableCampaign(true);
                if(langId && langId.id && projectTypeId && projectTypeId.id) {
                    setProjectPlaceholder('กำลังโหลด...');
                    const proj = await Utils.getProjectCode(langId.id, projectTypeId.id);
                    if(proj.data) {
                        setProject(proj.data);
                        setProjectPlaceholder('Select...');
                        setDisableProject(false);
                    }
                    else {
                        setProject(null);
                        setProjectPlaceholder('ไม่พบข้อมูล..');
                        setDisableProject(true);
                    }

                    if(projectId && projectId.project_code) {
                        setCampaignPlaceholder('กำลังโหลด...');
                        const camp = await Utils.getCampaign({
                            langId: langId.id,
                            projectType: projectTypeId.id,
                            projectCode: projectId.project_code,
                            campaignDate: campaignDate
                        });
                        let campaignList = [];
                        campaignList.push({
                            campaign_id: '0638A01',
                            campaign_name: 'NonDefine'
                        });
                        if(typeof camp !== 'undefined' && camp.data) {
                            if(camp.data[0].promotions) {
                                for(let rs of camp.data[0].promotions) {
                                    campaignList.push({
                                        campaign_id: rs.campaign_id,
                                        campaign_name: rs.campaign_name
                                    });
                                }
                            }
                            setCampaign(campaignList);
                            setCampaignPlaceholder('Select...');
                            setDisableCampaign(false);
                        }
                        else {
                            setCampaignId(campaignList[0]);
                        }
                        setCampaign(campaignList);
                        setCampaignPlaceholder('Select...');
                        setDisableCampaign(false);
                    }
                }

                //region Promotion
                const resCampaignType = await Utils.getCampaignType();
                setCampaignType(resCampaignType);
                const resBuType = await Utils.getBuType();
                setBuType(resBuType);if(langId && langId.id && campaignTypeId && campaignTypeId.id && buTypeId && buTypeId.id) {
                    setCampaignPlaceholder('กำลังโหลด...');
                    const prom = await Utils.getPromotion({
                        langId: langId.id,
                        campaignTypeId: campaignTypeId.id,
                        buTypeId: buTypeId.id,
                        campaignDate: campaignDate,
                        campaignId: campaignId ? campaignId.id : ''
                    });
                    if (typeof prom !== 'undefined' && prom.data) {
                        setCampaign(prom.data);
                        setCampaignPlaceholder('Select...');
                        setDisableCampaign(false);
                    } else {
                        setCampaign(null);
                        setCampaignPlaceholder('ไม่พบข้อมูล..');
                        setDisableCampaign(true);
                    }
                }
                //endregion

            } catch (e) {
                toast.error(e.message);
            }
        })();
    }, [langId, projectTypeId, projectId, campaignDate, campaignTypeId, buTypeId]);

    const onCreate = () => {
        let name = props.name;

        let items = [];
        if(roles.permissionId === Utils.SUPER_ADMIN_ID) {
            let checkboxes = document.getElementsByName('agencyIds[]');
            for (let i = 0; i < checkboxes.length; i++) {
                if(checkboxes[i].checked) {
                    items.push({'agencyId': checkboxes[i].value});
                }
            }
        }
        else {
            items.push({'agencyId': roles.agencyId});
        }

        if(!name) {
            toast.error("กรุณาระบุ ชื่อ Campaign Template");
        }
        else if(!typeId) {
            toast.error("กรุณาระบุ Type");
        }
        else if(!masterUrlId) {
            toast.error("กรุณาระบุ Master URL");
        }
        else if(!masterUrlForId) {
            toast.error("กรุณาระบุ Master URL For");
        }
        else if(!langId) {
            toast.error("กรุณาระบุ Language");
        }
        else if(masterUrlForId.id === Utils.GENERATE_TYPE_PROJECT && !projectTypeId) {
            toast.error("กรุณาระบุ Project Type");
        }
        else if(masterUrlForId.id === Utils.GENERATE_TYPE_PROJECT && !projectId) {
            toast.error("กรุณาระบุ Project");
        }
        else if(masterUrlForId.id === Utils.GENERATE_TYPE_PROJECT && !campaignId) {
            toast.error("กรุณาระบุ Campaign ID");
        }
        else if(masterUrlForId.id === Utils.GENERATE_TYPE_PROMOTION && !campaignTypeId) {
            toast.error("กรุณาระบุ Campaign Type");
        }
        else if(masterUrlForId.id === Utils.GENERATE_TYPE_PROMOTION && !buTypeId) {
            toast.error("กรุณาระบุ Bu Type");
        }
        else if(masterUrlForId.id === Utils.GENERATE_TYPE_PROMOTION && !campaignId) {
            toast.error("กรุณาระบุ Campaign ID");
        }
        else if(items.length <= 0) {
            toast.error("กรุณาระบุ Agency อย่างน้อย 1 รายการ");
        }
        else {
            confirmAlert({
                title: 'แจ้งเตือน',
                message: 'ต้องการบันทึกข้อมูล ?',
                buttons: [
                    {
                        label: 'ตกลง',
                        onClick: () => {
                            setLoading(true);

                            let statusChecked = document.getElementsByName('statusChecked');

                            const body = {
                                items: items,
                                name: name,
                                typeId: typeId ? typeId.id : null,
                                lang: langId ? langId.id : null,
                                projectTypeId: projectTypeId ? projectTypeId.id : null,
                                projectId: projectId ? projectId.project_code : null,
                                masterUrlId: masterUrlId ? masterUrlId.id : null,
                                campaignDate: campaignDate ? new Date(campaignDate) : null,
                                campaignId: campaignId ? campaignId.campaign_id : null,
                                masterUrlFor: masterUrlForId ? masterUrlForId.id : null,
                                campaignTypeId: campaignTypeId ? campaignTypeId.id : null,
                                buTypeId: buTypeId ? buTypeId.id : null,
                                url: masterUrlText,
                                status: statusChecked[0].checked ? 1:0,
                                createdBy: userId,
                                createdAt: moment().tz('Asia/Bangkok').format('YYYY-MM-DD HH:mm:ss'),
                                updatedAt: moment().tz('Asia/Bangkok').format('YYYY-MM-DD HH:mm:ss')
                            };
                                fetch(Config.url.API_URL +'/api/campaignTemplate/create', {
                                method: 'POST',
                                body: JSON.stringify(body),
                                headers: {
                                    'Content-Type':'application/json',
                                    'x-access-token': roles.accessToken
                                }
                            }).then(response => {
                                if(response.ok) {
                                    return response.json();
                                }
                                else {
                                    return response.json().then(err => Promise.reject(err));
                                }
                            }).then(result => {
                                if(result) {
                                    toast.success("บันทึกข้อมูลเรียบร้อย");
                                    setTimeout(function () {
                                        navigate('/campaignTemplate', {replace: true});
                                    }, 1500);
                                }
                                else {
                                    setLoading(false);
                                }
                            }).catch(err => {
                                toast.error(err.message);
                            })
                        }
                    },
                    {
                        label: 'ยกเลิก',
                        onClick: () => {}
                    }
                ]
            });
        }
    };

    const onChangeMasterURLId = (obj) => {
        setMasterUrlId(null);
        setMasterUrlText(null);
        if(obj) {
            setMasterUrlId(obj);
            setMasterUrlText(obj.url);
        }
    };

    const onChangeMasterUrlFor = (obj) => {
        setMasterUrlForId(obj);
    };

    const onChangeLanguageId = (obj) => {
        setLanguageId(obj);
        setProjectTypeId(null);
        setProject(null);
        setProjectId(null);
        setCampaign(null);
        setCampaignId(null);
    };

    const onChangeProjectTypeId = (obj) => {
        setProjectTypeId(obj);
        setProjectPlaceholder('...');
        setProject(null);
        setProjectId(null);
        setCampaign(null);
        setCampaignId(null);
    };

    const onChangeProjectId = (obj) => {
        setProjectId(obj);
        setCampaignPlaceholder('...');
        setCampaign(null);
        setCampaignId(null);
    };

    const onChangeCampaignDate = (value) => {
        setCampaignDate(value);
        setCampaign(null);
        setCampaignId(null);
    };

    const onChangeCampaignId = (obj) => {
        setCampaignId(obj);
    };

    //region Promotion
    const onChangeCampaignTypeId = (obj) => {
        setCampaignTypeId(obj);
        setBuTypeId(null);
        setCampaign(null);
        setCampaignId(null);
    };

    const onChangeBuTypeId = (obj) => {
        setBuTypeId(obj);
        setCampaign(null);
        setCampaignId(null);
    };
    //endregion

    return (
        <>
            <div className="col-12">
                <label htmlFor="masterURLId" className="form-label">Master URL <span className="text-danger">*</span></label>
                <Select
                    isDisabled={disableMasterUrl}
                    placeholder={masterUrlPlaceholder}
                    classNamePrefix="form-select-search"
                    options={masterUrl}
                    onChange={(event) => onChangeMasterURLId(event)}
                    value={masterUrlId}
                    getOptionValue={(option) => `${option.id}`}
                    getOptionLabel={(option) => `${option.id} : ${option.name}`}
                />
            </div>
            <div className="col-12">
                <label htmlFor="masterURLFor" className="form-label">Master URL For <span className="text-danger">*</span></label>
                <Select
                    isDisabled={disableMasterUrl}
                    placeholder={masterUrlPlaceholder}
                    classNamePrefix="form-select-search"
                    options={masterUrlFor}
                    onChange={(event) => onChangeMasterUrlFor(event)}
                    value={masterUrlForId}
                    getOptionValue={(option) => `${option.id}`}
                    getOptionLabel={(option) => `${option.id} : ${option.name}`}
                />
            </div>
            <div className="col-12">
                <label htmlFor="langId" className="form-label">Language <span className="text-danger">*</span></label>
                <Select
                    classNamePrefix="form-select-search"
                    options={lang}
                    onChange={(event) => onChangeLanguageId(event)}
                    value={langId}
                    getOptionValue={(option) => `${option.id}`}
                    getOptionLabel={(option) => `${option.name}`}
                />
            </div>
            <div className={"col-12" + (masterUrlForId && masterUrlForId.id === Utils.GENERATE_TYPE_PROJECT ? '':' d-none')}>
                <label htmlFor="projectTypeId" className="form-label">Project Type <span className="text-danger">*</span></label>
                <Select
                    classNamePrefix="form-select-search"
                    options={projectType}
                    onChange={(event) => onChangeProjectTypeId(event)}
                    value={projectTypeId}
                    getOptionValue={(option) => `${option.id}`}
                    getOptionLabel={(option) => `${option.name}`}
                />
            </div>
            <div className={"col-12" + (masterUrlForId && masterUrlForId.id === Utils.GENERATE_TYPE_PROJECT && projectTypeId ? '':' d-none')}>
                <label htmlFor="projectId" className="form-label">Project <span className="text-danger">*</span></label>
                <Select
                    isDisabled={disableProject}
                    classNamePrefix="form-select-search"
                    placeholder={projectPlaceholder}
                    options={project}
                    onChange={(event) => onChangeProjectId(event)}
                    value={projectId}
                    getOptionValue={(option) => `${option.project_code}`}
                    getOptionLabel={(option) => `${option.project_code} : ${option.project_title}`}
                />
            </div>
            <div className={"col-12" + (masterUrlForId && masterUrlForId.id === Utils.GENERATE_TYPE_PROJECT && projectTypeId ? '':' d-none')}>
                <label htmlFor="campaignDate" className="form-label">Campaign Date <span className="text-danger d-none">*</span></label>
                <DatePicker
                    selected={campaignDate}
                    onChange={(date) => onChangeCampaignDate(date)}
                    dateFormat="yyyy-MM-dd"
                    wrapperClassName="w-100"
                    className="form-control w-100" />
            </div>
            <div className={"col-12" + (masterUrlForId && masterUrlForId.id === Utils.GENERATE_TYPE_PROJECT && projectTypeId ? '':' d-none')}>
                <label htmlFor="campaignId" className="form-label">Campaign ID <span className="text-danger">*</span></label>
                <Select
                    isDisabled={disableCampaign}
                    classNamePrefix="form-select-search"
                    placeholder={campaignPlaceholder}
                    options={campaign}
                    onChange={(event) => onChangeCampaignId(event)}
                    value={campaignId}
                    getOptionValue={(option) => `${option.campaign_id}`}
                    getOptionLabel={(option) => `${option.campaign_id} : ${option.campaign_name}`}
                />
            </div>

            <div className={"col-12" + (masterUrlForId && masterUrlForId.id === Utils.GENERATE_TYPE_PROMOTION ? '':' d-none')}>
                <label htmlFor="campaignTypeId" className="form-label">Campaign Type <span className="text-danger">*</span></label>
                <Select
                    classNamePrefix="form-select-search"
                    options={campaignType}
                    onChange={(event) => onChangeCampaignTypeId(event)}
                    value={campaignTypeId}
                    getOptionValue={(option) => `${option.id}`}
                    getOptionLabel={(option) => `${option.name}`}
                />
            </div>
            <div className={"col-12" + (masterUrlForId && masterUrlForId.id === Utils.GENERATE_TYPE_PROMOTION ? '':' d-none')}>
                <label htmlFor="buTypeId" className="form-label">BU Type <span className="text-danger">*</span></label>
                <Select
                    classNamePrefix="form-select-search"
                    options={buType}
                    onChange={(event) => onChangeBuTypeId(event)}
                    value={buTypeId}
                    getOptionValue={(option) => `${option.id}`}
                    getOptionLabel={(option) => `${option.name}`}
                />
            </div>
            <div className={"col-12" + (masterUrlForId && masterUrlForId.id === Utils.GENERATE_TYPE_PROMOTION && campaignTypeId ? '':' d-none')}>
                <label htmlFor="campaignDate" className="form-label">Campaign Date <span className="text-danger d-none">*</span></label>
                <DatePicker
                    selected={campaignDate}
                    onChange={(date) => onChangeCampaignDate(date)}
                    dateFormat="yyyy-MM-dd"
                    wrapperClassName="w-100"
                    className="form-control w-100" />
            </div>
            <div className={"col-12" + (masterUrlForId && masterUrlForId.id === Utils.GENERATE_TYPE_PROMOTION && campaignTypeId ? '':' d-none')}>
                <label htmlFor="campaignId" className="form-label">Promotion ID <span className="text-danger">*</span></label>
                <Select
                    isDisabled={disableCampaign}
                    classNamePrefix="form-select-search"
                    placeholder={campaignPlaceholder}
                    options={campaign}
                    onChange={(event) => onChangeCampaignId(event)}
                    value={campaignId}
                    getOptionValue={(option) => `${option.promotion_url}`}
                    getOptionLabel={(option) => `${option.campaign_id} : ${option.promotion_name} : ${option.project_type_slug}`}
                />
            </div>
            <div className={"col-12" + (roles.permissionId === Utils.SUPER_ADMIN_ID ? '':' d-none')}>
                <label htmlFor="agencyx" className="form-label">Agency</label>
                {
                    agency === null || agency.length <= 0 ? (<p>ไม่พบข้อมูล</p>) :
                        agency.map((row, index) => {
                            let chkId = 'agencyCheck' + row.id;
                            return (
                                <div key={index} className="form-check ms-2">
                                    <input className="form-check-input" name="agencyIds[]" type="checkbox" value={row.id} id={chkId} />
                                    <label className="form-check-label" htmlFor={chkId}>
                                        {row.name} {row.isEncrypt ? <span className="badge bg-secondary small">encrypt</span>:''}
                                    </label>
                                </div>);
                        })
                }
            </div>

            <div className="col-12">
                <label htmlFor="statusx" className="form-label">สถานะ</label>
                <div className="form-check form-switch">
                    <input className="form-check-input" type="checkbox" name="statusChecked" id="status" defaultChecked={true} />
                    <label className="form-check-label" htmlFor="status"></label>
                </div>
            </div>
            <div className="col-12">
                <button type="button" className="btn btn-primary" onClick={onCreate} disabled={isLoading}><span
                    className={isLoading ? 'spinner-grow spinner-grow-sm' : 'd-none'}></span> {isLoading ? btnTextLoading : btnTextDefault}</button>
                <NavLink className="btn btn-sm btn-light ms-2" to='/campaignTemplate'><span><Icon.ArrowLeft/> กลับไป</span></NavLink>
                <Toaster position="bottom-right" />
            </div>
        </>
    );
} 